/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header{background-color:#101244}div.dialog{margin:-24px}.close{color:#fff;opacity:1}"];
export { styles as styles };
